const mousedownOutside = {
    async mounted(el, binding, vnode) {
        el.mousedownOutsideEvent = (event) => {
            if (!(el == event.target || el.contains(event.target))) {
                binding.value(event);
            }
        };
        setTimeout(() => {
            document.body.addEventListener('mousedown', el.mousedownOutsideEvent)
        }, 0)
    },
    unmounted(el) {
        document.body.removeEventListener('mousedown', el.mousedownOutsideEvent)
    },
}

export default mousedownOutside